/* LUMIRIS UK — product tabs (sections/lmr-product-tabs.liquid). Modelled on the Ornesse product tabs. */
(function () {
function initLumirisTabs(root) {
  if (!root || root.getAttribute('data-lpt-ready')) return;
  root.setAttribute('data-lpt-ready', '1');

  var tabs = [].slice.call(root.querySelectorAll('[data-lpt-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-lpt-panel]'));
  var HIDE_NOT_SPECIFIED = root.getAttribute('data-hide-not-specified') === 'true';

  /* ====================== TABS ====================== */
  /* Visible tabs in on-screen order (the mobile grid reorders them with CSS order) */
  function visibleTabs() {
    return tabs
      .filter(function (t) { return !t.hidden; })
      .map(function (t, i) { return { t: t, i: i, o: parseInt(getComputedStyle(t).order, 10) || 0 }; })
      .sort(function (a, b) { return a.o - b.o || a.i - b.i; })
      .map(function (x) { return x.t; });
  }

  function activate(key, opts) {
    opts = opts || {};
    var target = null;
    tabs.forEach(function (t) { if (!t.hidden && t.getAttribute('data-lpt-tab') === key) target = t; });
    if (!target) return false;
    tabs.forEach(function (t) {
      var on = t === target;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-lpt-panel') !== key; });
    if (opts.focus) target.focus();
    if (opts.scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function setHash(key) {
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + '#' + key);
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var key = t.getAttribute('data-lpt-tab');
      activate(key);
      setHash(key);
    });
    t.addEventListener('keydown', function (e) {
      var list = visibleTabs(), i = list.indexOf(t), next = null;
      if (e.key === 'ArrowRight') next = list[(i + 1) % list.length];
      else if (e.key === 'ArrowLeft') next = list[(i - 1 + list.length) % list.length];
      else if (e.key === 'Home') next = list[0];
      else if (e.key === 'End') next = list[list.length - 1];
      if (!next) return;
      e.preventDefault();
      activate(next.getAttribute('data-lpt-tab'), { focus: true });
    });
  });

  /* Links elsewhere on the page (e.g. href="#delivery-returns") open the matching tab */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || root.contains(a)) return;
    var key = a.getAttribute('href').slice(1);
    if (key && activate(key, { scroll: true })) {
      e.preventDefault();
      setHash(key);
    }
  });
  window.addEventListener('hashchange', function () {
    var key = decodeURIComponent((location.hash || '').slice(1));
    if (key) activate(key, { scroll: true });
  });

  /* ============ TECHNICAL SPECIFICATIONS ============ */
  var desc = root.querySelector('[data-lpt-desc]');
  var specBody = root.querySelector('[data-lpt-specs]');

  var MATCH = ['specifications', 'specification', 'technical details', 'technical data', 'tech specs'];
  var EMPTY_RE = /^(not\s*specified|not\s*provided|not\s*stated|unspecified|unknown|n\s*\/?\s*a|na|nc|-|–|—|\.)$/i;
  var VALUE_CORRECTIONS = [
    [/^hardwired$/i, 'Hardwired'],
    [/^hard\s*wired$/i, 'Hardwired'],
    [/^fil\s*dur$/i, 'Hardwired'],
    [/^plug[\s-]*in$/i, 'Plug-in'],
    [/^wall\s*mount(ed)?$/i, 'Wall-mounted'],
    [/^ceiling\s*mount(ed)?$/i, 'Ceiling-mounted'],
    [/^in[\s-]*ground$/i, 'In-ground'],
    [/^yes$/i, 'Yes'],
    [/^no$/i, 'No'],
    [/^none$/i, 'None'],
    [/^warm\s*white$/i, 'Warm white'],
    [/^cool\s*white$/i, 'Cool white'],
    [/^natural\s*white$/i, 'Natural white'],
    [/^dimmable$/i, 'Dimmable'],
    [/^not\s*dimmable$/i, 'Non-dimmable'],
    [/^easy$/i, 'Easy'],
    [/^color$/i, 'Colour'],
    [/\bE12\b/g, 'E14'],
    [/\bE26\b/g, 'E27']
  ];

  function clean(s) { return String(s || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function norm(s) { return clean(s).toLowerCase().replace(/[:\s]+$/, ''); }
  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function correct(v) {
    var s = clean(v);
    VALUE_CORRECTIONS.forEach(function (c) { if (c[0].test(s)) s = s.replace(c[0], c[1]); });
    return s;
  }

  function extract(node) {
    var out = [];
    if (!node) return out;
    if (node.tagName === 'TABLE') {
      node.querySelectorAll('tr').forEach(function (tr) {
        var c = tr.querySelectorAll('td, th');
        if (c.length >= 2) {
          var k = clean(c[0].textContent).replace(/[:\s]+$/, ''), v = clean(c[1].textContent);
          if (k && v) out.push([k, v]);
        }
      });
    } else if (node.tagName === 'UL' || node.tagName === 'OL') {
      node.querySelectorAll('li').forEach(function (li) {
        var st = li.querySelector('strong, b'), txt = clean(li.textContent), k, v;
        if (st && clean(st.textContent)) {
          k = clean(st.textContent).replace(/[:\s]+$/, '');
          v = txt.slice(txt.indexOf(k) + k.length).replace(/^[\s:]+/, '');
        } else {
          var p = txt.indexOf(':');
          if (p === -1) return;
          k = txt.slice(0, p).trim();
          v = txt.slice(p + 1).trim();
        }
        if (k && v) out.push([k, v]);
      });
    }
    return out;
  }

  function findSpecs() {
    if (!desc) return null;
    var heads = desc.querySelectorAll('h1, h2, h3, h4, h5, h6, p > strong, p > b');
    for (var i = 0; i < heads.length; i++) {
      var t = norm(heads[i].textContent);
      if (t.length >= 60 || !MATCH.some(function (m) { return t.indexOf(m) !== -1; })) continue;
      var isInline = heads[i].tagName === 'STRONG' || heads[i].tagName === 'B';
      var anchor = isInline ? heads[i].parentElement : heads[i];
      if (isInline && clean(anchor.textContent).length > clean(heads[i].textContent).length + 2) continue;
      var next = anchor.nextElementSibling;
      while (next && !/^(TABLE|UL|OL|DIV)$/.test(next.tagName) && clean(next.textContent) === '') next = next.nextElementSibling;
      if (!next) continue;
      var node = next;
      if (next.tagName === 'DIV') node = next.querySelector('table, ul, ol');
      var rows = extract(node);
      if (rows.length) return { anchor: anchor, container: next, rows: rows };
    }
    return null;
  }

  function rowHtml(k, v) { return '<tr><th scope="row">' + esc(k) + '</th><td>' + esc(v) + '</td></tr>'; }

  var found = findSpecs();
  if (found) {
    var rows = found.rows;
    if (HIDE_NOT_SPECIFIED) rows = rows.filter(function (r) { return !EMPTY_RE.test(clean(r[1])); });

    /* A free-standing light is never hardwired */
    var freestanding = rows.some(function (r) {
      return /light type|luminaire type|product type|fitting type/i.test(r[0]) &&
        /table lamp|floor lamp|bedside lamp|desk lamp|free[\s-]*standing/i.test(r[1]);
    });
    rows = rows.map(function (r) {
      var v = correct(r[1]);
      if (freestanding && /mounting|fixing|installation|wiring/i.test(r[0]) && /hardwired|hard\s*wired/i.test(v)) v = 'Free-standing';
      return [r[0], v];
    });

    found.anchor.parentNode.removeChild(found.anchor);
    found.container.parentNode.removeChild(found.container);
    if (rows.length) specBody.innerHTML = rows.map(function (r) { return rowHtml(r[0], r[1]); }).join('');
  }

  /* Size of the selected variant, kept in sync with the variant picker */
  function readJson(sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  (function mountSize() {
    if (!specBody.querySelector('tr')) return;
    var VARIANTS = readJson('[data-lpt-variants]') || [], OPTIONS = readJson('[data-lpt-options]') || [];
    var SIZE_RE = /size|dimension|length|height|diam|drop|format/i, NUM_RE = /\d\s*(cm|mm|m\b|")|Ø|×/i, sizeIdx = [];
    OPTIONS.forEach(function (name, i) {
      var numeric = VARIANTS.some(function (v) { return NUM_RE.test(String((v.options || [])[i] || '')); });
      if (SIZE_RE.test(name) || numeric) sizeIdx.push({ i: i, name: name || 'Size' });
    });
    if (!VARIANTS.length || !sizeIdx.length) return;

    var row = document.createElement('tr');
    specBody.insertBefore(row, specBody.firstChild);

    function current() {
      var p = new URLSearchParams(location.search).get('variant');
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = p || (input && input.value);
      var v = id && VARIANTS.filter(function (x) { return String(x.id) === String(id); })[0];
      return v || VARIANTS.filter(function (x) { return x.available; })[0] || VARIANTS[0];
    }
    function render() {
      var v = current(), opts = (v && v.options) || [];
      var parts = sizeIdx.map(function (s) { return opts[s.i]; }).filter(function (x) { return x && String(x).trim(); });
      if (!parts.length) { row.style.display = 'none'; return; }
      row.style.display = '';
      row.innerHTML = '<th scope="row">' + esc(sizeIdx[0].name) + '</th><td>' + esc(parts.join(' — ')) + '</td>';
    }
    render();
    document.addEventListener('change', render);
    var last = '';
    setInterval(function () {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var now = location.search + '|' + ((input && input.value) || '');
      if (now !== last) { last = now; render(); }
    }, 500);
  })();

  /* No specifications at all: hide the tab */
  if (!specBody.querySelector('tr')) {
    tabs.forEach(function (t) { if (t.getAttribute('data-lpt-tab') === 'specifications') t.hidden = true; });
  }

  /* Deep link on load (#specifications, #delivery-returns, #help…) */
  var initial = decodeURIComponent((location.hash || '').slice(1));
  if (initial) activate(initial, { scroll: true });
}

function initAll() { document.querySelectorAll('[data-lpt]').forEach(initLumirisTabs); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
else initAll();
document.addEventListener('shopify:section:load', initAll);
})();